import React, { useState } from "react";
import { Bar } from "@ant-design/charts";
import { DATA } from "../../../myanfinviz";
import * as _ from "lodash";
export const TotalAmtOfCapBarChart = () => {
  const USD_TO_MMK = 1410;
  const [country, setCountry] = useState("Myanmar");

  var newData = _.groupBy(DATA, (r) => r["Investing Country"]);
  console.log("TotalAmtOfCapBarChart newData", newData);
  newData = _.mapValues(newData, (r) => {
    console.log("TotalAmtOfCapBarChart mapValues", r);
    const finalTotal = _.reduce(
      r,
      (sum, n) => {
        const currency = n["Currency Of Total Amount"];
        var totalAmt = n["Total Amount Of Capital (in Millions)"];
        if (currency === "MMK") {
          totalAmt = parseInt(totalAmt, 10) / USD_TO_MMK;
        }
        return sum + totalAmt;
      },
      0
    );
    return {
      name: r[0]["Investing Country"],
      value: finalTotal,
    };
  });
  newData = _.orderBy(newData, (r) => r.value, "desc");
  console.log("TotalAmtOfCapBarChart data", newData);
  newData = _.chunk(newData, 10);
  console.log("TotalAmtOfCapBarChart chunk", newData);
  var config = {
    data: [...newData[0]],
    xField: "value",
    yField: "name",
    seriesField: "name",
    legend: { position: "top-left" },
  };

  return <Bar {...config} />;
};
